import React, { useState, useRef, useCallback, useEffect } from "react";
import AddIcon from "../../../assets/AddBankIcon.svg";
// import closemodalicon from "../../../../../Assets/closemodalicon.svg";
import backicon from "../../../../../Assets/backicon.svg";
import deleteIcon from "../../../assets/delete-icon.svg";
import { toast } from "react-toastify";

import CryptoIndex from "./CryptoModal/CryptoIndex";
import "../BankCards/BankCard.css";
import { $api } from "../../../../../../helpers/$api";

const Crypto = () => {
  const ref = useRef();
  const [section, setSection] = useState(0);
  const [wallets, setWallets] = useState([]);

  const asyncData = useCallback(async () => {
    try {
      const wallets = await $api.user.getSavedWallets();

      setWallets(wallets);
    } catch (error) {
      // error getting data...
    }
  }, [setWallets]);

  const handleDelete = async (wallet) => {
    const prv = wallets;
    try {
      // eslint-disable-next-line no-restricted-globals
      if (confirm("are you sure you want to delete this wallet")) {
        const w = wallets.filter((wa) => wa.id !== wallet.id);
        setWallets(w);

        await $api.user.deleteCryptoWallet(wallet.id);
        toast.success("wallet deleted successfully");
      }
    } catch (error) {
      toast.error(`error deleting wallet - ${error.message}`);
      setWallets(prv);
    }
  };

  const exitModal = () => {
    asyncData();
    const el = ref.current;
    if (el) {
      el.click();
    }
  };

  useEffect(() => {
    asyncData();
  }, [asyncData]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <a href="#CryptoModal">
          <div className="bank-details">
            <img src={AddIcon} alt="" className="bank-icon" />
            <p className="bank-text">Add crypto wallet</p>
          </div>
        </a>

        {wallets.map((wallet) => {
          return (
            <div className="details-nebbix bank-items" key={wallet.id}>
              <div className="delete-screen">
                <p
                  className="delete-button"
                  onClick={() => handleDelete(wallet)}
                >
                  <img
                    src={deleteIcon}
                    alt="delete-icon"
                    className="delete-icon"
                  />
                  <span
                    style={{
                      color: "#dd0707",
                    }}
                  >
                    Delete Card
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "90%",
                  margin: "auto",
                  display: "flex",
                  justifyContent: "space-evenly",
                  marginTop: "40px",
                }}
              >
                <div className="crypto-details">

                  <p>Coin host:</p>
                  <p>Wallet address:</p>
                </div>

                <div className=" crypto-details-d  ">
                  <p
                    style={{
                      fontWeight: "500",
                      color: "black",
                      textTransform: "capitalize",
                      fontSize: "1.2rem",
                      textAlign: "left",
                    }}
                  >
                    {wallet.coin_host}
                  </p>
                  <p
                    style={{
                      fontWeight: "500",
                      color: "black",

                      fontSize: "1.2rem",
                      textAlign: "left",
                    }}
                  >
                    {wallet.wallet_address}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <>
        <div id="CryptoModal" className="crypto-modal">
          <div className="accountmodal-head">
            {section === 0 ? (
              <a href="#dummy" ref={ref} className="backicon">
                <img src={backicon} alt="back icon" className="back-icon" />
              </a>
            ) : null}
            <CryptoIndex {...{ section, setSection, exitModal }} />
          </div>
        </div>
      </>
    </div>
  );
};

export default Crypto;
